module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-en4.03c4ffa.png";